import { Component, computed, DestroyRef, inject, Input, OnInit, signal } from '@angular/core';
import { CheckInSummaryModel } from "../check-ins-summary/check-ins-statuses";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CheckInsSummaryPopUpService } from "./check-ins-summary-pop-up.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { SurveySubmission } from "../shared-models/survey-submission.model";
import { IconComponent } from "../design-system/components/icon/icon.component";
import { NewLoadingComponent } from "../new-loading/new-loading.component";
import {
  CheckInsSummarySurveyListComponent
} from "../check-ins-summary-survey-list/check-ins-summary-survey-list.component";
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'lib-check-ins-summary-pop-up',
  standalone: true,
  imports: [
    IconComponent,
    NewLoadingComponent,
    CheckInsSummarySurveyListComponent,
    NgOptimizedImage
  ],
  templateUrl: './check-ins-summary-pop-up.component.html',
  styleUrl: './check-ins-summary-pop-up.component.scss'
})
export class CheckInsSummaryPopUpComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly checkInsSummaryPopUpService = inject(CheckInsSummaryPopUpService);
  private readonly destroy$ = inject(DestroyRef);

  @Input() checkInsSummary!: CheckInSummaryModel[];
  @Input() petId!: string;
  @Input() ownerId!: string;
  @Input() initialSurvey!: string;
  @Input() app!: number;

  surveySelected = signal<string>('');
  allSurveysSubmissions = signal<SurveySubmission[] | null>(null);
  isLoading = signal<boolean>(false);
  surveyToShow = signal<SurveySubmission | null>(null);
  surveyToShowFormatted= computed(() => {
    const s = this.surveyToShow();
    if (s) {
      return Object.entries(s.submissionData.surveyData).map(([key, value]) => {
        let customValue = value;
        let type = '';

        if (key === 'Photo Attached' && value?.length > 0) {
          customValue = value[0].content;
          type = 'img';
        } else if (typeof value === 'object') {
          if (Array.isArray(value)) {
            customValue = value.join(', ');
          } else {
            const keys = Object.keys(value);
            const result = keys.reduce((acc, a) => {
              acc += ` ${a} ${value[a]}, `;
              return acc;
            }, '');

            // remove the last ', ' and return string
            customValue = result.substring(0, result.length - 2);
          }
        }

        return {
          key,
          customValue,
          type
        }
      });
    }
    return [];
  });

  ngOnInit(): void {
    this.surveySelected.set(this.initialSurvey);
    this.pullSurveySubmissions();
  }

  onSurveyChange(surveyName: string): void {
    this.surveySelected.set(surveyName);
    this.selectSurveyToShow();
  }

  close(): void {
    this.activeModal.close();
  }

  private selectSurveyToShow(): void {
    const submissions = this.allSurveysSubmissions();
    if (submissions) {
      const selectedSurvey = submissions.find(
        (s) => s.surveyTitle === this.surveySelected()
      );
      this.surveyToShow.set(selectedSurvey || null);
    }
  }

  private pullSurveySubmissions(): void {
    this.isLoading.set(true);
    this.checkInsSummaryPopUpService
      .getSurveySubmissionsByOwnerAndAnimal(this.ownerId, this.petId, this.app)
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe({
        next: (submissions) => {
          this.allSurveysSubmissions.set(submissions);
          this.selectSurveyToShow();
          this.isLoading.set(false);
        },
        error: () => {
          console.error('Error fetching survey submissions');
          this.allSurveysSubmissions.set(null);
          this.isLoading.set(false);
        },
      });
  }

}
